import dayjs from 'dayjs'
import * as relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

function timeFromNow (isoDate) {
  isoDate ||= new Date(Date.now()).toISOString()
  const timeFromNowStr = `${dayjs(isoDate).fromNow(true)} ago`

  return capitalizeFirstLetter(timeFromNowStr)
}

function capitalizeFirstLetter(str) {
    if (!str) return str;
    return /^[a-zA-Z]/.test(str)
        ? str.charAt(0).toUpperCase() + str.slice(1)
        : str;
}

export default timeFromNow
